import { createCommand } from '@atlassian/rovo-content-bridge-api';

// Shared properties for all experience tracking commands

/**
 * Command for reporting the experience tracking status (success/failure/abort)
 * of an AI-first creation preview. Sent from the editor/iframe to the parent/host.
 */

export var AifcExperienceTrackingCommand = createCommand('aifc-experience-tracking-command');